import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { ManifestoProcess } from "@/components/landing/ManifestoProcess";
import { Offers } from "@/components/landing/Offers";
import { TickerMarquee } from "@/components/landing/TickerMarquee";
import { EventsTeaser } from "@/components/landing/EventsTeaser";
import { PodcastTeaser } from "@/components/landing/PodcastTeaser";
import { BlogTeaser } from "@/components/landing/BlogTeaser";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsapp } from "@/components/landing/FloatingWhatsapp";

export default function Landing() {
  useLenis();
  return (
    <div className="min-h-screen bg-[#FAFAF7]" data-testid="landing-page">
      <Header />
      <Hero />
      <ManifestoProcess />
      <Offers />
      <TickerMarquee />
      <EventsTeaser />
      <PodcastTeaser />
      <BlogTeaser />
      <FinalCTA />
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}
